import { Size } from '../Size';
import { Position } from '../Transform/Position';
import { Rotation } from '../Transform/Rotation';
import { Scale } from '../Transform/Scale';
import { GraphicElement } from './GraphicElement';
import { Group } from './Group';
export class BackPattern extends Group {
    constructor(
        engine,
        content,
        pos = new Position(),
        uuid = GraphicElement.generateUUID(),
        size = new Size(),
        options = {},
        scale = new Scale(),
        rotation = new Rotation()
    ) {
        super(engine, uuid, pos, size, options, scale, rotation);
        this.type = 'BackPattern';
        this._content = content;
        this.isDuplicated = false;
        this.transform.isMovable = false;
    }
    get canBeUnlocked() {
        return false;
    }
    set canBeUnlocked(canBeUnlocked) {
        this._canBeUnlocked = false;
    }
    get canBeSelected() {
        return false;
    }
    get isLocked() {
        return true;
    }
    static hydrate(data) {
        const backPattern = new BackPattern(
            data._engine,
            data._content,
            new Position(data.transform._pos._x, data.transform._pos._y),
            data._uuid,
            new Size(data.originSize._width, data.originSize._height)
        );
        backPattern.transform.resize(new Scale(data.transform._scale._scaleX, data.transform._scale._scaleY), true);
        backPattern.transform.rotate(data.transform._rotation._angle, true);
        backPattern.colorGroups = data._colorGroups;
        backPattern.options = data.options;
        backPattern.visible = data.visible;
        return backPattern;
    }
}
